import Index from "@pages/Index";
import Roster_dashboard from "@/pages/roster-dashboard/Roster_dashboard";
import Roster_wanted from "@pages/roster-wanted";
import Roster_view from "@/pages/roster-view/Roster_view";
import {
  RosterViewAllTab,
  RosterViewLegacyAllRedirect,
  RosterViewMyTab,
} from "@/pages/roster-view/Roster_view_outlet_routes";
import Roster_configure from "@pages/roster-config/Roster_configure.tsx";
import Account_management_mworks from "@pages/Account_management_mworks";
import Customer from "@/pages/support/Customer";
import type { ReactElement } from "react";
import RosterCreatePage from "@pages/roster-create/roster-create-page.tsx";
import RosterManagement from "@pages/roster-management/page.tsx";
import NotFound from "@pages/NotFound";
import MyPage from "@/pages/myPage/myPage";
import TokenLogin from "@/pages/TokenLogin";
import RosterShare from "@/pages/roster-share/RosterShare";
import { withWantedPermission } from "@/components/common/WithWantedPermission";

// HOC로 감싼 컴포넌트 생성
const ProtectedRosterWanted = withWantedPermission(Roster_wanted, {
  message: "원티드 요청은 소속 그룹에서만 요청이 가능합니다",
});
const ProtectedRosterView = withWantedPermission(Roster_view, {
  message: "근무표는 소속 그룹에서만 조회가 가능합니다",
});

// Route Configuration
export interface RouteConfig {
  path: string;
  element: ReactElement;
  isProtected?: boolean;
  doNotShowForHeadNurse?: boolean;
  /** 중첩 라우트에서만: `<Route index />` */
  index?: boolean;
  children?: RouteConfig[];
}

export const routes: RouteConfig[] = [
  {
    path: "/",
    element: <Index />,
    isProtected: false,
  },
  {
    path: "/schedule/:scheduleId?",
    element: <RosterShare />,
    isProtected: false, // 권한 없이 모두 접근 가능
  },
  {
    path: "/roster_dashboard", //대시보드
    element: <Roster_dashboard />,
    isProtected: true,
    doNotShowForHeadNurse: true,
  },
  {
    path: "/roster_wanted",
    element: <ProtectedRosterWanted />,
    isProtected: true,
  },
  {
    path: "/roster_view",
    element: <ProtectedRosterView />,
    isProtected: true,
    children: [
      {
        path: "",
        index: true,
        element: <RosterViewAllTab />,
        isProtected: true,
      },
      { path: "my", element: <RosterViewMyTab />, isProtected: true },
      {
        path: "all",
        element: <RosterViewLegacyAllRedirect />,
        isProtected: true,
      },
    ],
  },
  {
    path: "/head_nurse_management", // 근무자 관리
    element: <RosterManagement />,
    isProtected: true,
  },
  {
    path: "/roster_create", // 근무표 만들기
    element: <RosterCreatePage />,
    isProtected: true,
  },
  {
    path: "/roster_configure",
    element: <Roster_configure />,
    isProtected: true,
  },
  {
    path: "/myPage",
    element: <MyPage />,
    isProtected: true,
  },
  {
    path: "/Account_management_mworks",
    element: <Account_management_mworks />,
    isProtected: true,
  },
  {
    path: "/support",
    element: <Customer />, // 고객센터 (공지사항 기본)
    isProtected: true,
    children: [
      {
        path: "/support/inquiry",
        element: <Customer />, // 문의내역
        isProtected: true,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
    isProtected: false,
  },
  {
    // Token Login
    path: "/TokenLogin",
    element: <TokenLogin />,
    isProtected: false,
  },
];
